import { render } from "./PilotAnnouncementDetail.vue?vue&type=template&id=18a5582e&scoped=true"
import script from "./PilotAnnouncementDetail.vue?vue&type=script&lang=js"
export * from "./PilotAnnouncementDetail.vue?vue&type=script&lang=js"

import "./PilotAnnouncementDetail.vue?vue&type=style&index=0&id=18a5582e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a5582e"]])

export default __exports__